angular
	.module('siteTutorial.components', [])
	.component('siteTutorial', {
		templateUrl: 'ng/components/siteTutorial/siteTutorial.html',
		bindings: {
		},
		controllerAs: 'siteTutorialCtrl',
		controller: function ($scope, $rootScope, $location, $timeout, $portalService) {

			//Not to loose the *this reference
			var self = this;

			self.params = {
				//tutorialsFolder: 'media-resources/video/tutorial/'+$location.path(),
				tutorialIsVisible: false,
				tutorialsFolder: 'media-resources/video/tutorial',
				videoFolder: '/home',
				fileName: "help.mp4",
				videoPosterFileName: 'poster.png',
				videoUrl: '',
				videoPosterPath: ''
			};

			var video = document.getElementById('tutorial-video');
			var overlay = document.getElementById('tutorial-overlay');
			var wrapper = document.getElementById('wrapper');
			if (video && !video.paused) video.pause();


			self.$onInit = function () {
				/** Extract the map of the current language **/
				var currentLanguage = $rootScope.selectedLanguage;
				self.lang = langItems.filter(function (map) {
					return map.code == currentLanguage;
				}).map(function (value) {
					return value.map
				})[0];

				// load the default video (media-resources/video/tutorial/home/help.mp4)
				self.loadVideo();
				self.isAra = $portalService.isAra();
			}

			var getInnerViewPath = function(newValue){
				if(newValue) {
					switch (newValue) {
						case 'inner-view-wfinstances':
						case 'inner-view-wfactives':
						case 'inner-view-wftosign':
						case 'inner-view-order-table':
							return '/home';
						case 'inner-view-notifications':
							return '/communications';
						default:
							return '/home';	
					}
				}
			}

			self.loadVideo = function (route, innerView) {
					video.pause();
					var currentPath = $location.path();
					switch (route) {
						case '/':
							self.params.videoFolder = '/home';
							break;
						case '/leasingConfiguration':
							self.params.videoFolder = '/leasingConfiguration/Step_1';
							break;
						default:
							// default folder is the current path
							self.params.videoFolder = '/home';
							break;
					}
					console.log('self.params.videoFolder: ', self.params.videoFolder);
				

					self.params.videoUrl = self.params.tutorialsFolder + self.params.videoFolder + '/' + self.params.fileName;
					self.params.videoPosterPath = self.params.tutorialsFolder + self.params.videoFolder + '/' + self.params.videoPosterFileName;
		
					if(self.params.videoUrl.includes('/ri/')){
						self.params.videoUrl = self.params.videoUrl.replace('/ri/', '/leasingConfiguration/')
					}
		
					if(self.params.videoPosterPath.includes('/ri/')){
						self.params.videoPosterPath = self.params.videoPosterPath.replace('/ri/', '/leasingConfiguration/')
					}
		
					console.log("self.params.videoUrl"+self.params.videoUrl);
					console.log("self.params.videoPosterPath"+self.params.videoPosterPath);
					try {
						video.load();
					} catch(e) {
						console.log('Video loading failed! Path to video was ' + self.params.videoUrl + ', if it does not exist, ignore this error');
						return;
					}
					//video.play();
			}

			$rootScope.$on('loadTutorialVideo', function (event, args) {
				self.loadVideo(args.route, args.innerView);
			});

			self.showTutorial = function () {
				overlay.classList.remove('is-hidden');
				self.params.tutorialIsVisible = true;
				self.loadVideo(false);
			}

			self.dismissTutorial = function () {
				if (!video.paused) video.pause();
				overlay.classList.add('is-hidden');
				// hide the overlay after the animation is completed
				$timeout(function () {
					self.params.tutorialIsVisible = false;
					$scope.$apply();
				}, 500);
			}

			self.togglePlayPause = function () {
				video.paused ? video.play() : video.pause();
			}

			overlay.addEventListener('click', function (e) {
				// if clicking on the overlay (NOT the video), hide it
				if (e.target != video) self.dismissTutorial();
				// if the taget is the video, toggle play/pause (commented because of issues with touch devices)
				//else self.togglePlayPause();
			});
			/* overlay.addEventListener('dblclick', function(){
				// enter fullscreen mode
				if (!window.screenTop && !window.screenY) {
					if (video.mozRequestFullScreen) {
						video.mozRequestFullScreen();
					} else if (video.webkitRequestFullScreen) {
						video.webkitRequestFullScreen();
					}
				} else {
					// exit fullscreen mode
					if (video.mozExitFullScreen) {
						video.mozExitFullScreen();
					} else if (video.exitFullScreen) {
						video.exitFullScreen();
					}
				}
			});  */

			document.addEventListener('keydown', function (e) {
				// if the key is ESC, close the tutorial
				if (self.params.tutorialIsVisible && e.keyCode == 27) self.dismissTutorial();
				// if it's space play/pause the video
				else if (self.params.tutorialIsVisible && e.keyCode == 32) self.togglePlayPause();
			});

			// hide page content when the video is fullscreen to avoid elements overlapping
			$(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function (e) {
				if (!window.screenTop && !window.screenY) {
					//				wrapper.classList.remove('tutorialIsVisible');
				} else {
					// the video is in fullscreen mode
					//				wrapper.classList.add('tutorialIsVisible');
				}
			});

		}
	});